<div class="document-wrapper" id="pdf-content">
    <div class="content-header m-b-15">
        <h2 class="m-b-0 font-medium">{{ tempateData?.wpName }}</h2>
        <img src="{{env.assetUrl}}/Roche_Logo.png"/>
    </div>
    <div class="content">
        <div class="p-l-15 p-r-15 p-b-10 border-bottom-20">
            <label class="b2 text-primary font-medium">Background / Context</label>
            <p class="b2 m-b-0 text-80">{{ tempateData?.background }}</p>
        </div>
        <div class="dis-flex p-l-15 p-r-15 border-bottom-20">
            <!-- <div class="centricity-wrapper p-t-10 p-b-10 p-r-10 border-right-20">
                <label class="b2 text-primary font-medium">Customer Centricity</label>
                <p class="b2 m-b-0 text-80">Customers are repeated sharing that Roche needs to be more present (and available) in this space.  We have great medicine but it’s still new and therefore a lot of work is needed to build MD and patient confidence</p>
            </div> -->
            <div class="desired-outcome-wrapper p-t-10 p-b-10 p-l-10 p-r-10 border-right-20">
                <label class="b2 text-primary font-medium">Desired Outcome</label>
                <p class="b2 m-b-0 text-80">{{ tempateData?.outcome }}</p>
            </div>
            <div class="p-t-10 p-b-10 p-l-10">
                <label class="b2 text-primary font-medium">Key Milestone</label>
                <p class="b2 m-b-0 text-80"> {{ tempateData?.milestones }}</p>
            </div>
        </div>
        <div class="p-t-10 p-l-15 p-r-15 p-b-10 border-bottom-20">
            <label class="b2 text-primary font-medium">Capabilities & experience required</label>
            <ul class="m-b-0">
                <li class="b2 text-80" [innerHTML]="tempateData?.capabilities"></li>
                <!-- <li class="b2 text-80">Outbound Digital Marketing experience</li>
                <li class="b2 text-80">Local Ophtha community knowledge</li>
                <li class="b2 text-80">EPIcX proficiency</li>
                <li class="b2 text-80">LAB (Ophtha marketing materials knowledge)</li> -->
            </ul>
        </div>
        <div class="dis-flex p-l-15 p-r-15">
            <div class="team-wrapper p-t-10 p-b-10 p-r-10 border-right-20">
                <label class="b2 text-primary font-medium">Work Package Owner and Core Team</label>
                <p class="b2 m-b-0 text-80">{{getName }}</p>
            </div>
            <div class="resources-wrapper p-t-10 p-b-10 p-l-10 border-right-20">
                <label class="b2 text-primary font-medium">Resources Needed</label>
                <p class="b2 m-b-0 text-80">{{ tempateData?.resources }}</p>
            </div>
            <div class="tools-wrapper p-t-10 p-b-10 p-l-10 border-right-20">
                <label class="b2 text-primary font-medium">Tools</label>
                <p class="b2 m-b-0 text-80"> {{ tempateData?.tools }}</p>
            </div>
            <div class="timeframe-wrapper p-t-10 p-b-10 p-l-10 border-right-20">
                <label class="b2 text-primary font-medium">Timeframe</label>
                <p class="b2 m-b-0 text-80">{{ tempateData?.timeframe }}</p>
            </div>
            <div class="investment-wrapper p-t-10 p-b-10 p-l-10">
                <label class="b2 text-primary font-medium">Investment</label>
                <p class="b2 m-b-0 text-80">{{ tempateData?.investments }}</p>
            </div>
        </div>
    </div>
</div>

<button (click)="generatePDF()">Generate PDF</button>
